import { Typography } from '@remarkable/ark-web';
import { clsx } from 'clsx';

export function InfoWithLabel({
  label,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { label: React.ReactNode }) {
  return (
    <div className={clsx('flex flex-col gap-4', className)} {...props}>
      <Typography variant="interface-sm" className="text-muted">
        {label}
      </Typography>
      <div>{props.children}</div>
    </div>
  );
}
